<template lang="pug">
  div#appPortalSeguranca
    router-view
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">

  * {
    box-sizing: border-box;
    font-family: 'Ubuntu', sans-serif;
  }

  #appPortalSeguranca {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  body, #appPortalSeguranca {
    width: 100%;
    height: 100%;
    position: absolute;
    margin: 0;
    padding: 0;
  }

  h1, h2, h3, h4, h5, p {
    color: #424242;
  }

  .margin-top {
    margin-top: 10px;
  }

  .margin-bottom {
    margin-bottom: 10px;
  }

  .extra-margin-top {
    margin-top: 20px;
  }

  .extra-margin-bottom {
    margin-bottom: 20px;
  }

  p {
    margin: 0 0 10px;
  }

  main {
    height: 92%;
    width: 100%;
  }

  .full-size {
    width: 100%;
    height: 100%;
  }

  .content-route-view {
    padding-top: 20px;
    width: 100%;
  }

  .full-width {
    width: 100%;
  }

  .error {
    border: solid 1px firebrick;
    border-radius: 5px;
  }

  .clearfix::after {
    display: block;
    clear: both;
    content: "";
  }
</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/MainPage.vue